export const TOOL_PROVIDER_COMPANY = "company";
export const TOOL_PROVIDER_TEMP_WORKER = "temp_worker";
export const TOOL_PROVIDERS = [TOOL_PROVIDER_COMPANY, TOOL_PROVIDER_TEMP_WORKER];
export const DEFAULT_TOOL_PROVIDER = TOOL_PROVIDER_COMPANY;

const TOOL_PROVIDER_LABEL_DEFAULTS = {
    [TOOL_PROVIDER_COMPANY]: "Entreprise",
    [TOOL_PROVIDER_TEMP_WORKER]: "Intérimaire",
};

// Some names of the "tools" referential start with a space, so names are
// compared trimmed and case-insensitively.
export const toolNameKey = (name) =>
    typeof name === "string" ? name.trim().toLowerCase() : "";

export const normalizeToolProvider = (provider) =>
    TOOL_PROVIDERS.includes(provider) ? provider : DEFAULT_TOOL_PROVIDER;

// Normalizes tools coming from the API or the referential: legacy templates
// may still hold plain strings.
export const normalizeTemplateTools = (input) => {
    if (!Array.isArray(input)) return [];
    const seenKeys = new Set();
    return input.reduce((tools, item) => {
        const rawName = typeof item === "string" ? item : item?.name;
        const key = toolNameKey(rawName);
        if (!key || seenKeys.has(key)) return tools;
        seenKeys.add(key);
        tools.push({
            name: rawName.trim(),
            providedBy: normalizeToolProvider(item?.providedBy),
        });
        return tools;
    }, []);
};

export const toToolNames = (input) =>
    normalizeTemplateTools(input).map((tool) => tool.name);

export const getToolProviderLabel = (language, provider) => {
    const normalizedProvider = normalizeToolProvider(provider);
    const fallback = TOOL_PROVIDER_LABEL_DEFAULTS[normalizedProvider];
    return language.getValue(
        `missionTemplate.tools.provider.${normalizedProvider}`,
        fallback
    );
};

export const formatTemplateToolsWithProvider = (input, language) =>
    normalizeTemplateTools(input)
        .map(
            (tool) =>
                `${tool.name} (${getToolProviderLabel(
                    language,
                    tool.providedBy
                )})`
        )
        .join(", ");
